import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { getUserSession } from "../../../core/util/core/Session";

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const session = getUserSession();

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/cardeal-points/save`,
        endpointGetById: `${endpointBackend}gci/cardeal-points/getById`,
        urlGoBack: `/gci/cardeal-points/list`,
        pathView: `/gci/cardeal-points/view`
    }

    const labels = {
        labelTitleAdd: "Nova Orientação/Localização",
        labelTitleEdit: "Editar Orientação/Localização",
        labelTitleView: 'Visualizar Orientação/Localização'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
